import { getEnvVariable } from 'utils/env';

export const APPLICATIONINSIGHTS_CONNECTION_STRING = getEnvVariable(
  'adminAppInsightsConnectionString',
  process.env.APPLICATIONINSIGHTS_CONNECTION_STRING,
);
